export function OutlineIconsboxIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.296 18.2452L11.376 20.6788C11.7792 20.818 12.2208 20.818 12.624 20.6788L19.704 18.2452C20.4816 17.9812 21 17.2516 21 16.4308V8.3524C21 7.5316 20.4768 6.802 19.704 6.538L12.624 4.1044C12.2208 3.9652 11.7792 3.9652 11.376 4.1044L4.296 6.5332C3.5184 6.7972 3 7.5268 3 8.3476V16.426C3 17.2468 3.5184 17.9764 4.296 18.2404V18.2452Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 7.22461L12 9.88861L21 7.22461"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M12 10.0703V20.8895"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M16.0801 5.28906L7.4209 8.53386V12.7243"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
